import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import { sum } from 'lib/array/arrayUtils'

interface Props {
  variants: Array<App.MerchandiseOfferVariant>
}

const MIN_INVENTORY = 5

function MerchandiseLowStockMessage({ variants }: Props) {
  const intl = useIntl()
  const totalInventory = useMemo(
    () => sum(variants.map(variant => variant.inventory ?? 0)),
    [variants],
  )

  if (!totalInventory || totalInventory > MIN_INVENTORY) {
    return null
  }

  return <BodyText variant="medium" colour="critical" weight="bold">
    {intl.formatMessage(
      {
        id: '8ybHgZSc6g',
        defaultMessage: '{count, plural, one {# left in stock} other {# left in stock}}',
        description: 'Label showing low stock quantity for merchandise',
      },
      { count: totalInventory },
    )}
  </BodyText>
}

export default MerchandiseLowStockMessage
